import { render, staticRenderFns } from "./org.vue?vue&type=template&id=60f09c0c&scoped=true"
import script from "./org.vue?vue&type=script&lang=js"
export * from "./org.vue?vue&type=script&lang=js"
import style0 from "./org.vue?vue&type=style&index=0&id=60f09c0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f09c0c",
  null
  
)

export default component.exports